import classNames from 'classnames';
import { HTMLAttributes } from 'react';

export function DebugComment(props: HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props} className={classNames('italic text-gray-300 font-normal', props.className)} />
  )
}
